export enum RichTextToolbarMode {
  DEFAULT = "DEFAULT",
  LINK = "LINK",
  NONE = "NONE",
}
